<template>
  <CRUDPage
      :resultHeaders="resultHeaders"
      resource="mail_template"
      title="メールテンプレートマスタ一覧"
      schemaName="MailTemplate"
  >
  </CRUDPage>
</template>
<script>
import CRUDPage from "@/components/CRUDPage";

export default {
  components: {CRUDPage},
  data() {
    return {
      resultHeaders: [
        {text: 'No', value: 'id'},
        {text: 'メール区分', value: 'type'},
        {text: 'タイトル', value: 'title'},
        {
          text: 'Actions',
          value: 'actions',
          sortable: false
        },
      ],
    }
  }
}
</script>
